interface IInfiniteScrollScope extends angular.IScope {
    infiniteScroll?: Function;
}

export class InfiniteScrollDirective implements angular.IDirective {
    restrict = 'A';
    scope = {
        infiniteScroll: '&'
    };

    link = ($scope: IInfiniteScrollScope, element: angular.IAugmentedJQuery, $attr: angular.IAttributes) => {
        if (!$attr["infiniteScroll"] || !$attr["infiniteScroll"].trim())
            console.error('infinite scroll requires a function to work.');

        const rawElement = element[0];
        
        element.on('scroll', () => {
            const scroll = rawElement.scrollTop + rawElement.offsetHeight + 5;
            if (scroll >= rawElement.scrollHeight) {
                $scope.infiniteScroll();
            }
        });
    };

    static factory(): angular.IDirectiveFactory {
        return () => new InfiniteScrollDirective();
    }
}

angular.module('deliveryCreate.app')
    .directive('infiniteScroll', InfiniteScrollDirective.factory());


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/infiniteScroll/infiniteScrollDirective.ts
 **/